import HelpDsfr from "components/templates/helpDsfr/HelpDsfr";
import elementsTypes from "utils/elementsTypes";

export default {
  key: "HELPDSFR",
  label: "Aide et contact (DSFR)",
  Component: HelpDsfr,
  initialContents: [
    {
      key: "subtitle",
      type: elementsTypes.EDITABLE_INPUT,
      value: "",
    },
    {
      key: "thematicTitle",
      type: elementsTypes.EDITABLE_INPUT,
      value: "",
    },
    {
      key: "thematicTilesList",
      type: elementsTypes.DYNAMIC,
      value: "",
      children: [],
    },
    {
      key: "faqTitle",
      type: elementsTypes.EDITABLE_INPUT,
      value: "Vous ne parvenez pas à vous connecter à votre compte ?",
    },
    {
      key: "faqSubtitle",
      type: elementsTypes.EDITABLE_INPUT,
      value: "Vous êtes...",
    },
    {
      key: "faqCardsList",
      type: elementsTypes.DYNAMIC,
      value: "",
      children: [],
    },
    {
      key: "contactTitle",
      type: elementsTypes.EDITABLE_INPUT,
      value: "Vous n'avez pas trouvé la réponse que vous cherchiez ?",
    },
    {
      key: "contactUsTitle",
      type: elementsTypes.EDITABLE_INPUT,
      value: "Contactez-nous:",
    },
    {
      key: "dynamicPartOnForm",
      type: elementsTypes.DYNAMIC,
      value: "",
      children: [],
    },
    {
      key: "reverseTabsOrder",
      type: elementsTypes.ALONE_CHECKBOX_NO_LABEL,
      value: "false",
    },
    {
      key: "contactForm",
      value: "",
      children: [
        {
          key: "title",
          type: elementsTypes.EDITABLE_INPUT,
          value: "Par formulaire",
        },
        {
          key: "subTitle",
          type: elementsTypes.TEXT,
          value: "Le moyen le plus efficace pour contacter nos équipes",
        },
        {
          key: "delay",
          type: elementsTypes.TEXT,
          value: "Vous recevrez une réponse en moins de 24 heures",
        },
        {
          key: "description",
          type: elementsTypes.TEXT,
          value:
            "Afin d'avoir tous les éléments concernant votre dossier et pour mieux répondre a vos questions, nous vous conseillons de renseigner dans ce message les champs suivants",
        },
      ],
    },
    {
      key: "ContactFormProfilesList",
      type: elementsTypes.CONTACT_FORM_PROFILE_LIST,
      value: "",
      children: [
        {
          key: "ContactFormProfiles",
          type: elementsTypes.CONTACT_FORM_PROFILE,
          value: "",
          children: [
            {
              key: "title",
              type: elementsTypes.INPUT,
              value: "Particulier",
            },
          ],
        },
        {
          key: "ContactFormProfiles",
          type: elementsTypes.CONTACT_FORM_PROFILE,
          value: "",
          children: [
            {
              key: "title",
              type: elementsTypes.INPUT,
              value: "Ecole de conduite",
            },
          ],
        },
        {
          key: "ContactFormProfiles",
          type: elementsTypes.CONTACT_FORM_PROFILE,
          value: "",
          children: [
            {
              key: "title",
              type: elementsTypes.INPUT,
              value: "Centre de sensibilisation à la sécurité routière",
            },
          ],
        },
        {
          key: "ContactFormProfiles",
          type: elementsTypes.CONTACT_FORM_PROFILE,
          value: "",
          children: [
            {
              key: "title",
              type: elementsTypes.INPUT,
              value: "Personne morale",
            },
          ],
        },
        {
          key: "ContactFormProfiles",
          type: elementsTypes.CONTACT_FORM_PROFILE,
          value: "",
          children: [
            {
              key: "title",
              type: elementsTypes.INPUT,
              value: "Mairie",
            },
          ],
        },
        {
          key: "ContactFormProfiles",
          type: elementsTypes.CONTACT_FORM_PROFILE,
          value: "",
          children: [
            {
              key: "title",
              type: elementsTypes.INPUT,
              value: "Professionnel de la vente automobile habilité",
            },
          ],
        },
        {
          key: "ContactFormProfiles",
          type: elementsTypes.CONTACT_FORM_PROFILE,
          value: "",
          children: [
            {
              key: "title",
              type: elementsTypes.INPUT,
              value: "Loueur",
            },
          ],
        },
        {
          key: "ContactFormProfiles",
          type: elementsTypes.CONTACT_FORM_PROFILE,
          value: "",
          children: [
            {
              key: "title",
              type: elementsTypes.INPUT,
              value: "Centre VHU",
            },
          ],
        },
        {
          key: "ContactFormProfiles",
          type: elementsTypes.CONTACT_FORM_PROFILE,
          value: "",
          children: [
            {
              key: "title",
              type: elementsTypes.INPUT,
              value: "Expert",
            },
          ],
        },
        {
          key: "ContactFormProfiles",
          type: elementsTypes.CONTACT_FORM_PROFILE,
          value: "",
          children: [
            {
              key: "title",
              type: elementsTypes.INPUT,
              value: "Huissier",
            },
          ],
        },
        {
          key: "ContactFormProfiles",
          type: elementsTypes.CONTACT_FORM_PROFILE,
          value: "",
          children: [
            {
              key: "title",
              type: elementsTypes.INPUT,
              value: "Assureur",
            },
          ],
        },
        {
          key: "ContactFormProfiles",
          type: elementsTypes.CONTACT_FORM_PROFILE,
          value: "",
          children: [
            {
              key: "title",
              type: elementsTypes.INPUT,
              value: "Démolisseur",
            },
          ],
        },
      ],
    },
    {
      key: "ContactFormSubjectsList",
      type: elementsTypes.CONTACT_FORM_SUBJECT_LIST,
      value: "",
      children: [],
    },
    {
      key: "contactPhone",
      value: "",
      children: [
        {
          key: "title",
          type: elementsTypes.EDITABLE_INPUT,
          value: "Par téléphone",
        },
        {
          key: "description",
          type: elementsTypes.TEXT,
          value:
            "Les usagers peuvent joindre le Centre de Contact Citoyens du lundi au vendredi de 9h à 17h (heure métropolitaine).",
        },
        {
          key: "detail",
          value: "",
          children: [
            {
              key: "icon1",
              type: elementsTypes.ICON_DSFR,
              value: "",
              children: [
                {
                  key: "iconDSFR",
                  type: elementsTypes.SELECT,
                  value: "phone-line",
                },
                {
                  key: "groupDSFR",
                  type: elementsTypes.SELECT,
                  value: "Device",
                },
              ],
            },
            {
              key: "phone1",
              type: elementsTypes.TEXT,
              value: "34 00 en France métropolitaine (numéro non surtaxé)",
            },
            {
              key: "icon2",
              type: elementsTypes.ICON_DSFR,
              value: "",
              children: [
                {
                  key: "iconDSFR",
                  type: elementsTypes.SELECT,
                  value: "phone-line",
                },
                {
                  key: "groupDSFR",
                  type: elementsTypes.SELECT,
                  value: "Device",
                },
              ],
            },
            {
              key: "phone2",
              type: elementsTypes.TEXT,
              value: "09 70 83 07 07 depuis l'Outre-Mer et l'étranger",
            },
            {
              key: "iconWebcallback",
              type: elementsTypes.ICON_DSFR,
              value: "",
              children: [
                {
                  key: "iconDSFR",
                  type: elementsTypes.SELECT,
                  value: "calendar-2-line",
                },
                {
                  key: "groupDSFR",
                  type: elementsTypes.SELECT,
                  value: "Business",
                },
              ],
            },
            {
              key: "webcallback",
              type: elementsTypes.TEXT,
              value: "",
            },
            {
              key: "icon3",
              type: elementsTypes.ICON_DSFR,
              value: "",
              children: [
                {
                  key: "iconDSFR",
                  type: elementsTypes.SELECT,
                  value: "ear-off-line",
                },
                {
                  key: "groupDSFR",
                  type: elementsTypes.SELECT,
                  value: "Others",
                },
              ],
            },
            {
              key: "phone3",
              type: elementsTypes.TEXT,
              value:
                "L'Agence nationale des titres sécurisés permet aux personnes sourdes et malentendantes d'accéder par téléphone à son centre de support.",
            },
            {
              key: "deafAccess",
              type: elementsTypes.BUTTON,
              value: "",
              children: [
                {
                  key: "text",
                  value: "Accès sourds et malentendants",
                },
                {
                  key: "link",
                  type: elementsTypes.LINK,
                  value: "",
                  children: [
                    {
                      key: "url",
                      type: elementsTypes.URL,
                      value: "https://www.acce-o.fr/client/ants",
                    },
                    {
                      key: "title",
                      type: elementsTypes.INPUT,
                      value: "Ouverture d'une nouvelle page vers le service ACCEO",
                    },
                    {
                      key: "external",
                      type: elementsTypes.CHECKBOX,
                      value: "true",
                    },
                  ],
                },
                {
                  key: "primary",
                  type: elementsTypes.CHECKBOX,
                  value: "true",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      key: "contactDigitalPointsTitle",
      type: elementsTypes.EDITABLE_INPUT,
      value: "Trouvez quelqu’un pour vous aider :",
    },
    {
      key: "contactDigitalPoints",
      value: "",
      children: [
        {
          key: "title",
          type: elementsTypes.EDITABLE_INPUT,
          value: "Dans les points numériques ou les France Services",
        },
        {
          key: "description",
          type: elementsTypes.TEXT,
          value: "Faites vous accompagner dans vos démarches par un médiateur.",
        },
        {
          key: "detail",
          value: "",
          children: [
            {
              key: "text",
              type: elementsTypes.TEXT,
              value:
                "Vous n'avez pas d'accès à internet ? Vous souhaitez être guidé-e pour réaliser votre demande en ligne ? Vous pouvez être accompagné-e dans un des points numériques de votre département, en préfecture ou sous-préfecture, où une personne vous aidera à faire votre démarche.",
            },
            {
              key: "digitalPoint",
              type: elementsTypes.BUTTON,
              value: "",
              children: [
                {
                  key: "text",
                  value: "Trouver un point numérique",
                },
                {
                  key: "link",
                  type: elementsTypes.LINK,
                  value: "",
                  children: [
                    {
                      key: "url",
                      type: elementsTypes.URL,
                      value: "",
                    },
                    {
                      key: "external",
                      type: elementsTypes.CHECKBOX,
                      value: "true",
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
